import React from 'react';
import Hero from '../components/Hero/Hero';
import ServicesPreview from '../components/Services/ServicesPreview';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';
import SectionCurve from '../components/SectionCurve/SectionCurve';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <SectionCurve from="primary" to="secondary" hideBase overlap />
      <ServicesPreview />
      <SectionCurve from="secondary" to="primary" />
      <About />
      <SectionCurve from="primary" to="contact" />
      <Contact />
    </>
  );
};

export default HomePage;
